<template>
  <div class="perform-content_evaluate problem1">
    <div class="eval-label">
      {{title}}
    </div>
    <div class="eval-select">
      <a
        class="eval-btn"
        v-for="(item, index) in options"
        :key="index"
        @click="Option(index)"
        :class="{active: submit_data[type][keys] === (index+1)}"
      >{{item}}</a>
    </div>
    <div
      class="tip tip-options"
      v-if="!alreadySent"
    >* 请选择{{title}}</div>
  </div>
</template>
<script>
export default {
  props: { title: {}, type: {}, keys: {} },
  mounted () {
    // console.log('props', this.type)
    this.new_type = this.type
    // console.log('new_type', this.new_type)
  },
  data () {
    return {
      options: ['满意', '基本满意', '不满意'],
      new_type: '',
      alreadySent: false,
      submit_data: {
        'work_evaluate': { // 履职满意度
          'department': '五华区司法局', // 被评价单位
          'xzqh_name': '五华区', // 行政区划名称
          'xzqh': '530102', // 行政区划代码
          'overall_evaluate': '', // 一级指标
          'data_sources': '02', // 数据来源
          'pjqd': '1', // 评价渠道
          'other_evaluate': '', // 其他意见和评价
          'service': '', // 二级指标-服务态度
          'efficiency': '', // 二级指标-效率
          'environment': '', // 二级指标-环境
          'capability': '1', // 二级指标-能力
          'discipline': '' // 二级指标-廉洁
        },
        'bus_evaluate': { // 工作业务满意度
          'department': '五华区司法局',
          'xzqh_name': '五华区',
          'xzqh': '530102',
          'service_type': '',
          'overall_evaluate': '',
          'data_sources': '02',
          'pjqd': '1',
          'other_evaluate': '',
          'service': '',
          'efficiency': '',
          'environment': '',
          'capability': '',
          'discipline': ''
        }
      }
    }
  },
  methods: {
    Option (index) {
      // this.$emit('sendOption', that.type, that.keys, index + 1)
      this.$emit('sendOption', this.type, this.keys, index + 1)
      this.alreadySent = true
      this.submit_data[this.type][this.keys] = index + 1
    }
  }
}
</script>
<style lang="stylus" scoped>
.perform-content_evaluate
  display flex
  align-items center
  margin-top 0.4rem
  &.perform-content_problems
    align-items flex-start
    margin-top 0.3rem
  &.problem1
    margin-top 0.2rem
  &.problem2
    margin-top 0.2rem
  .eval-label
    color #333
    font-size 0.2rem
    text-align right
    width 1rem
  .eval-select
    display flex
    margin-left 0.25rem
    flex-wrap wrap
  .eval-btn
    display block
    width 1.2rem
    height 0.45rem
    border solid 0.01rem #e5e5e5
    text-align center
    line-height 0.45rem
    margin-right 0.2rem
    font-size 0.2rem
    color #333
    &.active
      border 0.02rem solid #5168b6
      text-align center
      line-height 0.4rem
      // font-size 0.36rem
      color #5168b6
      position relative
      &:after
        content url('/wstatic/img/icon/induce1.png')
        width 0.07rem
        height 0.05rem
        bottom 0.19rem
        position absolute
        right -0.01rem
      &:before
        content ''
        width 0
        height 0
        right 0
        bottom 0
        border 0.05rem solid transparent
        border-right 0.05rem solid transparent
        border-bottom 0.05rem solid transparent
        border-style solid
        position absolute
        border-bottom-color #5168b6
        border-right-color #5168b6
.tip
  color #e73131
  font-size 0.19rem
  margin-left 1.24rem
  margin-top 0.14rem
  &.tip-options
    margin 0
</style>
